import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Button,
  Box,
  Typography
} from '@mui/material';

import { DOCUMENT_CATEGORIES } from '../../../constants/documentConstants';

const EditDocumentDialog = ({
  open,
  onClose,
  document,
  onSave,
  loading = false
}) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    type: 'other',
    isClientVisible: false
  });

  useEffect(() => {
    if (document && open) {
      setFormData({
        name: document.name || '',
        description: document.description || '',
        type: document.type || 'other',
        isClientVisible: document.visibility === 'both' || document.isClientVisible || false
      });
    }
  }, [document, open]);

  const handleChange = (field) => (event) => {
    const value = field === 'isClientVisible' ? event.target.checked : event.target.value;
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = () => {
    onSave(formData);
  };

  const handleClose = () => {
    onClose();
    // Reset form when dialog closes
    setFormData({
      name: '',
      description: '',
      type: 'other',
      isClientVisible: false
    });
  };

  const isFormValid = formData.name.trim().length > 0;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Edit Document
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: 1 }}>
          <TextField
            label="Document Name"
            value={formData.name}
            onChange={handleChange('name')}
            fullWidth
            required
            error={!isFormValid && formData.name.trim().length === 0}
            helperText={!isFormValid && formData.name.trim().length === 0 ? 'Name is required' : ''}
          />

          <TextField
            label="Description"
            value={formData.description}
            onChange={handleChange('description')}
            fullWidth
            multiline
            rows={3}
            placeholder="Optional description of the document"
          />

          <FormControl fullWidth>
            <InputLabel>Document Category</InputLabel>
            <Select
              value={formData.type}
              onChange={handleChange('type')}
              label="Document Category"
            >
              {DOCUMENT_CATEGORIES.map((category) => (
                <MenuItem key={category.value} value={category.value}>
                  {category.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControlLabel
            control={
              <Checkbox
                checked={formData.isClientVisible}
                onChange={handleChange('isClientVisible')}
                color="primary"
              />
            }
            label="Client Visible"
          />

          {formData.isClientVisible && (
            <Typography variant="caption" color="textSecondary" sx={{ mt: -2 }}>
              This document will be visible to the client in their project dashboard
            </Typography>
          )}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          disabled={!isFormValid || loading}
        >
          {loading ? 'Saving...' : 'Save Changes'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditDocumentDialog;